import _ from 'lodash';
import $ from 'jquery';
import moment from 'moment';
import ShowableWidget from 'gears/ui/showable-widget/component';
import scrollParent from 'gears/util/scroll-parent/component';

// Accepted Formats (delimeter could be any non-digit character):
// DD (assumes current month / year, adds DD to 1st of the month to allow values greater than 31)
// MMDD (assumes current year)
// MMDDYY (assumes current year)
// MMDDYYYY
// MM/DD (assumes current year)
// MM/DD/YY
// MM/DD/YYYY
// YYYY/MM/DD
// Sep 15 (assumes current year)
// Sep 15, YY
// Sep 15, YYYY
// September 15 (assumes current year)
// September 15, YY
// September 15, YYYY
let formats = {
  "DD": /^(\d{1,2})$/,
  "MMDD": /^(\d{2})(\d{2})$/,
  "MMDDYY": /^(\d{2})(\d{2})(\d{2})$/,
  "MMDDYYYY": /^(\d{2})(\d{2})(\d{4})$/,
  "MM/DD": /^(\d{1,2})[\W-](\d{1,2})$/,
  "MM/DD/YY": /^(\d{1,2})[\W-](\d{1,2})[\W-](\d{2})$/,
  "MM/DD/YYYY": /^(\d{1,2})[\W-](\d{1,2})[\W-](\d{4})$/,
  "YYYY/MM/DD": /^(\d{4})[\W-](\d{1,2})[\W-](\d{1,2})$/,
  "MMM/DD": /^(\w{3})[\W-]+\d{1,2}$/,
  "MMM/DD/YYYY": /^(\w{3})[\W-]+\d{1,2}[\W-]+\d{4}$/,
  "MMM/DD/YY": /^(\w{3})[\W-]+\d{1,2}[\D]+\d{2}$/,
  "MMMM/DD": /^(\w{3,9})[\W-]+\d{1,2}$/,
  "MMMM/DD/YY": /^(\w{3,9})[\W-]+\d{1,2}[\D]+\d{2}$/,
  "MMMM/DD/YYYY": /^(\w{3,9})[\W-]+\d{1,2}[\D]+\d{4}$/
};

// used to keep track so there's never two datepickers shown at once
let _shownDatepicker = null;

export function popupTopPosition({inputHeight, inputTop, popupHeight, position}) {
  let calculatedPosition = position
  // If the the popup is too tall to fit below, position it above
  if (position === 'dynamic') {
    calculatedPosition = inputTop + inputHeight + popupHeight > window.innerHeight ? 'top' : 'bottom'
  }

  if (calculatedPosition === 'top') {
    return inputTop - popupHeight - 1;
  }
  return inputTop + inputHeight - 1;
}


class Datepicker extends ShowableWidget {

  show() {
    // hide any currently shown datepicker
    if (_shownDatepicker !== this) { __guard__(_shownDatepicker, x => x.hide()); }
    _shownDatepicker = this;
    return super.show(...arguments);
  }

  hide() {
    _shownDatepicker = null;
    return super.hide(...arguments);
  }

  destroy() {
    if (this.options && this.options.trigger) {
      $(this.options.trigger).off(`.${this._getNamespace()}`);
    }
    $(this.$scrollParent).off(`.${this._getNamespace() + this.wid}`);
    __guard__(this.$form, x => x.off(`.${this._getNamespace() + this.wid}`));
    __guard__(this.$target, x1 => x1.off(`.${this._getNamespace()}`));
    return super.destroy(...arguments);
  }

  _hideAndFocus() {
    this.hide();
    return setTimeout(() => {
      return __guard__(this.$target, x => x.focus().select());
    }
    , 0);
  }

  _onHidden() {
    $(window).off(`.${this._getNamespace() + this.wid}`);
    $(document).off(`.${this._getNamespace() + this.wid}`);
    $(this.$scrollParent).off(`.${this._getNamespace() + this.wid}`);
    __guard__(this.$target, x => x.off(`input.${this._getNamespace()}`));
    this.$calendar = null;
    return super._onHidden(...arguments);
  }

  _initialize() {
    super._initialize(...arguments);
    let $form = this.$target.closest("form");
    if ($form.length) { this.$form = $form; }
    this.$scrollParent = scrollParent(this.$target);
    return this._setEvents();
  }

  _update() {
    if ((this.changedOptions.showOnFocus != null) || (this.changedOptions.trigger != null)) { return this._setEvents(); }
  }


  _render() {
    this.today = moment();
    this.selectedDate = this._parseDateField();
    this.moment = this.selectedDate ? moment(this.selectedDate, "MM/DD/YYYY") : moment();
    this.maxDate = this.options.maxDate ? moment(this.options.maxDate, "MM/DD/YYYY") : undefined;
    this.$el = $(`\
<section class="${Datepicker.className}">
<nav class="${Datepicker.className}__nav">
<div class="${Datepicker.className}__control-prev">
  <button type="button" class="js-prev-year ${Datepicker.className}__control-button button"><span title="Previous Year" class="${Datepicker.className}__control-icon icon icon-backward" /></button>
  <button type="button" class="js-prev-month ${Datepicker.className}__control-button button"><span title="Previous Month" class="${Datepicker.className}__control-icon icon icon-caret-left" /></button>
</div>
<h1 class="${Datepicker.className}__month" />
<div class="${Datepicker.className}__control-next">
  <button type="button" class="js-next-month ${Datepicker.className}__control-button button"><span title="Next Month" class="${Datepicker.className}__control-icon icon icon-caret-right" /></button>
  <button type="button" class="js-next-year ${Datepicker.className}__control-button button"><span title="Next Year" class="${Datepicker.className}__control-icon icon icon-forward" /></button>
</div>
</nav>
<div class="datepicker__footer">
<button type="button" class="js-today ${Datepicker.className}__control-button button">Today</button>
<button type="button" class="js-clear ${Datepicker.className}__control-button button">Clear</button>
</div>
</section>\
`);
    this._renderMonth();
    return this._setCalendarEvents();
  }


  _renderMonth() {
    let $tbody;
    let firstDayOfMonth = moment([this.moment.year(), this.moment.month()]);
    let weeksInMonth = Math.ceil( (firstDayOfMonth.day() + firstDayOfMonth.daysInMonth()) / 7 );

    this._hideNextButtonsIfNeeded(firstDayOfMonth);

    if (this.$calendar) {
      $tbody = this.$calendar.find("tbody").empty();
    } else {
      this.$calendar = $(`\
<div class="${Datepicker.className}__calendar">
<table>
<thead><tr><th>Su</th><th>Mo</th><th>Tu</th><th>We</th><th>Th</th><th>Fr</th><th>Sa</th></tr></thead>
<tbody></tbody>
</table>
</div>\
`).insertAfter(this.$el.children("nav"));
      $tbody = this.$calendar.find("tbody");
    }

    _.times(weeksInMonth, () => {
      $tbody.append(this._renderWeek(firstDayOfMonth));
      return firstDayOfMonth.add("weeks", 1);
    }
    );
    return this.$el.find(`.${Datepicker.className}__month`).html(this.moment.format("MMMM YYYY"));
  }

  _hideNextButtonsIfNeeded(firstDayOfMonth) {
    if (!this.maxDate) {
      return;
    }

    if (moment(firstDayOfMonth).add(1, 'months').isAfter(this.maxDate)) {
      this.$el.find('.js-next-month').hide();
    } else {
      this.$el.find('.js-next-month').show();
    }

    if (moment(firstDayOfMonth).add(1, 'years').isAfter(this.maxDate)) {
      this.$el.find('.js-next-year').hide();
    } else {
      this.$el.find('.js-next-year').show();
    }
  }

  _renderWeek(original) {
    let self = this;
    let today = moment().format("MM/DD/YYYY");
    let clone = original.clone().subtract("days", original.day());
    let $week = $(document.createElement("tr"));
    _.times(7, function() {
      let cloneDate = clone.format("MM/DD/YYYY");
      let cls = `${Datepicker.className}__day`;
      if (clone.month() !== self.moment.month()) { cls += ` ${Datepicker.className}__day--non-month`; }
      if (cloneDate === today) { cls += ` ${Datepicker.className}__day--today`; }
      if (cloneDate === self.selectedDate) { cls += " is-selected"; }
      if (self.maxDate && clone.isAfter(self.maxDate)) { cls += " is-disabled"; }
      $(document.createElement("td")).append(`\
<div class="${cls}" data-date="${cloneDate}">${clone.date()}</div>\
`).appendTo($week);
      return clone.add("days", 1);
    });

    return $week;
  }


  _position() {
    // determine if the position should be absolute or static based on the input ancestor"s positions
    let positions = this.$target.parents().map( function() { return $(this).css("position"); });
    let position = Array.from(positions).includes("fixed") ? "fixed" : "absolute";

    // calculate the position coordinates
    // Default left align with input
    let offset = this.$target.offset();
    let datepickerTop = popupTopPosition({
      inputHeight: this.$target.outerHeight(),
      inputTop: offset.top,
      popupHeight: this.$el.outerHeight(),
      position: this.options.position
    });
    let datepickerLeft = offset.left;
    let widgetWidth = this.$el.outerWidth();

    // If cut off, align with right of input
    if ((datepickerLeft + widgetWidth) > $(window).width()) {
      datepickerLeft = (offset.left + this.$target.parent().width()) - widgetWidth;
    }

    // Otherwise, center in screen
    if (datepickerLeft < 0) {
      datepickerLeft = ($(window).width() - widgetWidth) / 2;
    }

    // if position is fixed and we're scrolled down in the document
    // we need to account for that difference
    if (position === "fixed" && this.options.position !== "dynamic") { datepickerTop -= $(window).scrollTop(); }

    return this.$el.css({top: datepickerTop, left: datepickerLeft, position});
  }


  _shiftDate(modifier) {
    let selectedDate = this._parseDateField();
    if (selectedDate) {
      let m = moment(selectedDate, "MM/DD/YYYY");
      modifier(m);
      let newDate = m.format("MM/DD/YYYY");
      this._changeDate(newDate);
      if (_shownDatepicker) {
        this.moment = m;
        this.selectedDate = newDate;
        return this._renderMonth();
      }
    }
  }

  _setEvents() {

    let self = this;

    self.$target.on(`focusout.${self._getNamespace()}`, function(e) {
      self._setDate();
      if (!self.clickingOnTrigger) { return self.hide(); }
    });

    // Use keypress here becase we're interested in characher codes not key codes
    self.$target.on(`keypress.${self._getNamespace()}`, function(e) {
      if ([43, 45].includes(e.which)) { // the `+` or `-` key
        e.preventDefault();
        let method = e.which === 43 ? "add" : "subtract";
        // consider adding this back in to support holding shift to
        // increase/decrease the month instead of the day
        // It's a little weird since `+` sometimes requires the shift
        // key to press in the first place.
        // amount = if e.shiftKey then "month" else "day"
        let amount = "day";
        return self._shiftDate(m => m[method](amount, 1));
      }
    });

    // Bind an event to the form and parse the datefield before submitting
    __guard__(self.$form, x => x.on(`submit.${self._getNamespace() + self.wid}`, e => self._setDate()));

    if (self.changedOptions.showOnFocus === false) {
      self.$target.off(`focusin.${self._getNamespace()}`);
    }
    if (self.options.showOnFocus === true) {
      self.$target.on(`focusin.${self._getNamespace()}`, _.bind(self.show, self));
    }

    if (self.options.trigger) {
      $(self.previousOptions.trigger).first().off(`.${self._getNamespace()}`);
      $(self.options.trigger).first().on(`mousedown.${self._getNamespace()}`, e => self.clickingOnTrigger = true);
      return $(self.options.trigger).first().on(`click.${self._getNamespace()}`, function(e) {
        self.clickingOnTrigger = false;
        return self.show();
      });
    }
  }

  _setCalendarEvents() {

    let self = this;

    // Allow the mouse wheel to move the datepicker forward and backward by month
    self.$el.on(`mousewheel.${self._getNamespace()} DOMMouseScroll.${self._getNamespace()}`, function(e) {
      e.preventDefault();
      let scrollUp = (e.originalEvent.detail < 0) || (e.originalEvent.wheelDelta > 0);
      if (scrollUp) {
        self.moment.subtract("months", 1);
      } else {
        self.moment.add("months", 1);
      }
      return self._renderMonth();
    });

    // for browsers that suppor the input event,
    // update the calendar when a new date is entered
    self.$target.on(`input.${self._getNamespace()}`, function(e) {
      let newDate = self._parseDateField();
      if (newDate && (newDate !== self.selectedDate)) {
        let m = moment(newDate);
        if (m.isValid() && (newDate === m.format("MM/DD/YYYY"))) {
          self.moment = m;
          self.selectedDate = newDate;
          return self._renderMonth();
        }
      }
    });

    self.$el.on(`click.${self._getNamespace()}`,
      ".js-prev-year, .js-prev-month, .js-next-month, .js-next-year, .js-today, .js-clear",
      function(e) {
        let $this = $(this);
        if ($this.hasClass("js-prev-year")) {
          self.moment.subtract("years", 1);
          return self._renderMonth();
        }
        if ($this.hasClass("js-prev-month")) {
          self.moment.subtract("months", 1);
          return self._renderMonth();
        }
        if ($this.hasClass("js-next-month")) {
          self.moment.add("months", 1);
          return self._renderMonth();
        }
        if ($this.hasClass("js-next-year")) {
          self.moment.add("years", 1);
          return self._renderMonth();
        }
        if ($this.hasClass("js-today")) {
          self._changeDate(moment().format("MM/DD/YYYY"));
          self._hideAndFocus();
        }
        if ($this.hasClass("js-clear")) {
          self._changeDate("");
          return self._hideAndFocus();
        }
    });

    self.$el.on(`click.${self._getNamespace()}`, `.${Datepicker.className}__day`, function(e) {
      if ($(this).hasClass("is-disabled")) {
        return;
      }

      self._changeDate($(this).attr("data-date"));
      self.$calendar.find(".is-selected").removeClass("is-selected");
      self._hideAndFocus();
      return $(this).addClass(".is-selected");
    });

    $(document).on(`keydown.${self._getNamespace() + self.wid}`, function(e) {
      if (e.which === 27) { // ESC
        self._setDate();
        return self._hideAndFocus();
      }
    });

    $(document).on(`click.${self._getNamespace() + self.wid}`, function(e) {
      // Hide the datepicker unless the clicked event target is whitelisted
      let $whitelist = $(self.$el).add(self.$target).add(self.options.trigger);
      if (!$(e.target).closest($whitelist).length) { return self.hide(); }
    });

    if (this.options.position === 'dynamic') {
      $(this.$scrollParent).on(`scroll.${self._getNamespace() + self.wid}`,
        _.debounce( () => self._position()
        , 100)
      );
    }

    return $(window).on(`resize.${self._getNamespace() + self.wid}`,
      _.debounce( () => self._position()
      , 100)
    );
  }


  _setDate() {
    let date = this._parseDateField(true);
    if (date) { return this._changeDate(date); }
  }


  _changeDate(date) {
    this.selectedDate = date;
    return this.$target.val(date).trigger(this._getNamespace() + ":change");
  }


  _parseDateField() {
    // remove leading whitespace and trailing non-digit characters
    // e.g. convert " sept 14th" to "sept 14"
    let dateString = this.$target.val().replace(/(^\s*)|(\D+$)/g, "");

    // convert all delimiters to a slash for simplicity
    dateString = dateString.replace(/[\W-]+/g, "/");

    for (let format in formats) {
      let regex = formats[format];
      if (regex.test(dateString)) {

        // add the current year to formats without it
        switch (format) {
          case "DD":
            format = "MM/DD/YYYY";
            dateString = moment().date(1).add("days", parseInt(dateString, 10) - 1).format(format);
            break;
          case "MMDD":
            format = "MMDDYYYY";
            dateString += `${moment().year()}`;
            break;
          case "MM/DD":
            format = "MM/DD/YYYY";
            dateString += `/${moment().year()}`;
            break;
          case "MMM/DD":
            format = "MMM/DD/YYYY";
            dateString += `/${moment().year()}`;
            break;
          case "MMMM/DD":
            format = "MMMM/DD/YYYY";
            dateString += `/${moment().year()}`;
            break;
        }

        let m = moment(dateString, format);
        return m.isValid() && m.format("MM/DD/YYYY");
      }
    }

    return false;
  }
}

Datepicker.className = "datepicker";

Datepicker.namespace = "gears:datepicker";

Datepicker.defaults = {
  animate: true,
  destroyOnHidden: false,
  position: 'bottom',
  removeOnHidden: true,
  showOnFocus: false
};
export default Datepicker;

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
